module.exports = "data:image/gif;base64,R0lGODlhIAAgAMQAAPPz83zHGX3HGXzGGHvGGIaGhlFhFRI9FjcwEjUkADUcED0YDCAcABQcAFEEBBwQCCQMABQQAD0AADEAAC0AAAgICCQAABwAABQABAwAAAQAAP///wAAAAAAAAAAAAAAACH5BAEHABsALAAAAAAgACAAAAWx4CaOZGmeaKqubOu+cCzPdG0WhX3iteb/wKAwWKpsCMgkQZOZDH9KwkEjMh6jGqTmwWggH5dM1qecUkVYcjSNiE7XyIsmAVf6LIdydk3xQepJP3lJb2sOPhGAWj6DSIVRhxoKiksYGo1Se1F9GguUGnKYj0qcnoqCenV9GJ9QhGdXSWIWrWqOG2drF4tqQEuamSJUcD8XFBI/FpxRBhoAI0/R0i48Ojs51tna29zd3jMhADs="


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/Car/CHeadW_S2.gif
// module id = NBxg
// module chunks = 50